import React, { useContext, useEffect, useState } from 'react';
import Button from '../ClubRegistrationButton/ClubRegistrationButton';
import TileHeader from '../ClubRegistrationTileHeader/ClubRegistrationTileHeader';
import Styles from './PingNationClubRegistrationTile.module.scss';
import ClubList from '../ClubList/ClubList';
import { LocalizationContext } from '../../context/localizationContext';
import { clubsContext } from '../../context/clubsContext';
import APIClient from '../../helpers/APIClient';
import LoadingSpinner from '../ClubRegistrationLoadingSpinner/ClubRegistrationLoadingSpinner';
import ArrowRight from '../../assets/images/icons/arrow-left.svg';
import NoClubs from '../../assets/images/no-clubs-image.svg';
import keys from '../../keys.json';

const PingNationClubRegistrationTile = (props) => {
  const localization = useContext(LocalizationContext);
  const { localizationState } = localization;
  const { tileText } = localizationState.localization;
  const clubContext = useContext(clubsContext);
  const { state, dispatch } = clubContext;
  const { userClubs } = state;
  const [clubList, setClubList] = useState(userClubs?.length ? userClubs : []);
  const [serviceDown, setServiceDown] = useState(false);
  const [loading, setLoading] = useState(false);
  const { isTileView, toggleModal, getClubCount } = props;
  const { linkKeys } = keys;

  const getAllSerials = () => {
    setLoading(true);
    APIClient.getAllSerials((status, resp) => {
      if (status === 200) {
        dispatch({ type: 'SET_USER_CLUBS', clubs: resp.data });
        setServiceDown(false);
      } else {
        setServiceDown(true);
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    getAllSerials();
  }, []);

  useEffect(() => {
    if (isTileView) {
      getAllSerials();
    }
  }, [isTileView]);

  useEffect(() => {
    if (userClubs?.length) {
      setClubList(userClubs);
    } else {
      setClubList([]);
    }
  }, [userClubs]);

  const handleViewClubsClick = () => {
    dispatch({ type: 'SET_LINK_KEY', key: linkKeys?.myClubs });
    toggleModal();
  };

  const getClubsCountText = () => {
    return tileText.viewClubsButton.replace(
      '"{club_count_placeholder}"',
      clubList?.length ? getClubCount(clubList) : 0,
    );
  };

  const getTileContent = () => {
    if (loading) {
      return (
        <div className={Styles.loadingContainer}>
          <LoadingSpinner />
        </div>
      );
    }
    if (clubList.length) {
      return (
        <div className={Styles.clubListTileContainer}>
          <ClubList isTileView={isTileView} />
          <div className={Styles.footer}>
            <button
              className={Styles.viewClubsFooterBtn}
              type="button"
              onClick={() => handleViewClubsClick()}
            >
              {getClubsCountText()}
              <img src={ArrowRight} alt="arrow-right" />
            </button>
          </div>
        </div>
      );
    }

    if (serviceDown) {
      return <div className={Styles.serviceDown}>{tileText?.serviceDown}</div>;
    }

    return (
      <div className={Styles.noClubsMessage}>
        <img src={NoClubs} alt="no-clubs" />
        <div className={Styles.noClubsMessageTxt}>{tileText?.noClubs}</div>
        <Button
          label={tileText.registerBtn}
          onClick={toggleModal && toggleModal}
        />
      </div>
    );
  };

  return (
    <div className={Styles.tile}>
      <TileHeader toggleModal={toggleModal} serviceDown={serviceDown} />
      {getTileContent()}
    </div>
  );
};

export default PingNationClubRegistrationTile;
